import React from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import BookingForm from "@/components/BookingForm";
import { COMPANY } from "@/data/content";
import { CONTACT } from "@/constants/testIds";

export default function ContactPage() {
  return (
    <section id="contact" data-testid={CONTACT.section} className="section">
      <div className="container-owrs">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Contact details column */}
          <div className="lg:col-span-5">
            <div className="overline mb-4">06 — Get In Touch</div>
            <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tighter leading-[1.05] mb-8">
              Drop us a line — <br />
              <span className="text-[var(--owrs-accent)]">we'll do the rest.</span>
            </h2>

            <p className="text-base text-[var(--owrs-text-muted)] leading-relaxed mb-10 max-w-md">
              Use the booking form to request a date, or get in touch directly using any of
              the details below.
            </p>

            <div className="space-y-5">
              <DetailRow
                icon={<Phone className="h-4 w-4" />}
                label="Call"
                value={
                  <a
                    href={`tel:${COMPANY.phoneTel}`}
                    data-testid={CONTACT.phoneLink}
                    className="hover:text-[var(--owrs-accent)] transition-colors"
                  >
                    {COMPANY.phone}
                  </a>
                }
              />
              <DetailRow
                icon={<Mail className="h-4 w-4" />}
                label="Email"
                value={
                  <a
                    href={`mailto:${COMPANY.email}`}
                    data-testid={CONTACT.emailLink}
                    className="hover:text-[var(--owrs-accent)] transition-colors break-all"
                  >
                    {COMPANY.email}
                  </a>
                }
              />
              <DetailRow
                icon={<MapPin className="h-4 w-4" />}
                label="Workshop"
                value={
                  <div>
                    {COMPANY.addressLines.map((l) => (
                      <div key={l}>{l}</div>
                    ))}
                  </div>
                }
              />
              <DetailRow
                icon={<Clock className="h-4 w-4" />}
                label="Opening Hours"
                value={COMPANY.hours}
              />
            </div>
          </div>

          {/* Booking form column */}
          <div className="lg:col-span-7">
            <BookingForm />
          </div>
        </div>
      </div>
    </section>
  );
}

function DetailRow({ icon, label, value }) {
  return (
    <div className="flex items-start gap-4">
      <div className="h-9 w-9 shrink-0 inline-flex items-center justify-center border border-[var(--owrs-border-strong)] text-[var(--owrs-accent)]">
        {icon}
      </div>
      <div>
        <div className="overline mb-1 !text-[var(--owrs-text-muted)]">{label}</div>
        <div className="text-base text-[var(--owrs-text)] leading-relaxed">{value}</div>
      </div>
    </div>
  );
}
